export const environment = {
  production: true,
  makecodeSandboxUrl:
    "https://arcade.makecode.com/v4.0.14?controller=1&ninja=1",
  apiUrl: "https://app-curriculum-api-development.azurewebsites.net",
  imagesHostUrl: "https://app-curriculum-api-development.azurewebsites.net",
  filesHostUrl:
    "https://app-curriculum-api-development.azurewebsites.net/files",
  assetsUrl: "https://stninjadevelopmentd86a.blob.core.windows.net",
  auth: {
    authority:
      "https://login.microsoftonline.com/5579b019-54e6-459c-9753-f2b37829ba5e",
    clientId: "752eab2e-2980-4734-9b94-1d3d43f5caf6",
    redirectUri: "https://curriculum.dev.codeninjas.com",
  },
  publishAllowedMails: [
    "chaitanya.ponnapati@codeninjas.com",
    "ed.kim@codeninjas.com",
    "sara.smolevitz@codeninjas.com",
    "bill.marsland@codeninjas.com",
  ],
  envName: "dev",
};
